import React, { FC, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { eventHandlerConfigSelector } from '../selectors';
import { getSystemConfig } from '../../../System/systemConfig';
import { Section, SectionHeading } from '../../../common/Section';
import { Table } from 'reactstrap';
import { renderEventHandlerConfiguration } from '..';
import { uniqueBy } from '../../../../utils';
import { EventHandlerConfiguration } from '../../../../services/account';

export const MissingEventHandlers: FC<{}> = () => {
    const eventHandlerConfigState = useSelector(eventHandlerConfigSelector);

    const [missingEventHandlers, setMissingEventHandlers] = useState<EventHandlerConfiguration[]>([]);

    useEffect(() => {
        const servers = Object.keys(getSystemConfig().serverUrls);

        let all = uniqueBy(
            servers.flatMap(server => (eventHandlerConfigState[server] ? eventHandlerConfigState[server].handler : [])),
            (e: EventHandlerConfiguration) => e.eventName
        );

        const missing: EventHandlerConfiguration[] = uniqueBy(
            servers.flatMap(server => (eventHandlerConfigState[server] ? eventHandlerConfigState[server].missing : [])),
            (e: EventHandlerConfiguration) => e.eventName
        );

        const overAllMissing = missing
            .filter(m => all.find(a => a.eventName === m.eventName) === undefined)
            .sort((e1, e2) => e1.eventName.localeCompare(e2.eventName));
        setMissingEventHandlers(overAllMissing);
    }, [eventHandlerConfigState]);

    return (
        <>
            <Section>
                <SectionHeading>Missing Event Handlers</SectionHeading>
                <small>
                    <Table>
                        <thead>
                            <tr>
                                <th>Event</th>
                                <th>Destinations</th>
                                <th>Listener</th>
                                <th>Receiving Queue</th>
                            </tr>
                        </thead>
                        <tbody>
                            {missingEventHandlers &&
                                missingEventHandlers.map((e, index) => renderEventHandlerConfiguration(e, index))}
                        </tbody>
                    </Table>
                </small>
            </Section>
        </>
    );
};
